import { Group, Text, TextProps, useMantineTheme } from "@mantine/core"
import { IconCheck, IconX } from "@tabler/icons-react"
import { Missing } from "@tfg/ui"
import { useTranslation } from "react-i18next"

type Props = {
  value?: boolean
} & TextProps

export const BoolCell = ({ value, ...textProps }: Props) => {
  const { colors } = useMantineTheme()
  const { t } = useTranslation()

  if (value === true) {
    return (
      <Group gap="xs">
        <IconCheck color={colors.green[6]} size={20} />
        <Text {...textProps}>{t("yes")}</Text>
      </Group>
    )
  } else if (value === false) {
    return (
      <Group gap="xs">
        <IconX color={colors.red[6]} size={20} />
        <Text {...textProps}>{t("no")}</Text>
      </Group>
    )
  }
  return <Missing {...textProps} />
}
